export default __webpack_public_path__ + "static/media/close-circle.9bb9ef8c.svg";